import _ from "lodash";
import {
  EnumOperatorPricing,
  EnumOperatorType,
  SeasonalityEnum,
} from "gql/generated";
import i18n from "i18next";
import { i18nNamespace, loadLanguagePacks } from "i18n.ts";
import { Months } from "shared/types";

// Ensure the required language packs are loaded
await loadLanguagePacks([i18nNamespace.Core]);

export const businessTypeOptions = _.sortBy(
  Object.values(EnumOperatorType).map((val) => {
    return {
      label: i18n.t(`core:LOOKUPS.OPERATOR_TYPE.${val}`),
      value: val,
    };
  }),
  "label",
);

// Explicitly state the enum options to maintain a certain order
export const seasonalityOptions = Object.values([
  SeasonalityEnum.High,
  SeasonalityEnum.Low,
  SeasonalityEnum.Closed,
])
  .map((val) => {
    return {
      label: i18n.t(`core:LOOKUPS.SEASONALITY.${val}`),
      value: val as SeasonalityEnum,
    };
  })
  .filter((option) => option.value && option.value.length > 0);

export const monthsShortOptions = Object.values(Months).map((val) => {
  return {
    label: i18n.t(`core:LOOKUPS.MONTHS.${val}_SHORT`),
    value: val,
  };
});

export const pricingOptions = _.sortBy(
  Object.values(EnumOperatorPricing).map((val) => {
    return {
      label: i18n.t(`core:LOOKUPS.OPERATOR_PRICING.${val}`),
      value: val,
    };
  }),
  "label",
);
